import JsonDisplayValue from './JsonDisplayValue'
import { isPeachIdValue } from './jsonHelpers'
import AppDomainLink from './links/AppDomainLink'
import AutopayPlanLink from './links/AutopayPlanLink'
import CaseLink from './links/CaseLink'
import CaseTypeLink from './links/CaseTypeLink'
import CompanyLink from './links/CompanyLink'
import ContactLink from './links/ContactLink'
import DocumentLink from './links/DocumentLink'
import DrawLink from './links/DrawLink'
import EmployeeLink from './links/EmployeeLink'
import InvestorLink from './links/InvestorLink'
import LoanLink from './links/LoanLink'
import LoanTypeLink from './links/LoanTypeLink'
import PaymentInstrumentLink from './links/PaymentInstrumentLink'
import PersonLink from './links/PersonLink'
import PurchaseLink from './links/PurchaseLink'
import RoleLink from './links/RoleLink'
import ServiceLink from './links/ServiceLink'
import SupercaseLink from './links/SupercaseLink'
import TeamLink from './links/TeamLink'
import TransactionLink from './links/TransactionLink'
import UserLink from './links/UserLink'
import WorkflowSmartLink from './links/WorkflowSmartLink'
import WorkflowTypeLink from './links/WorkflowTypeLink'

const JsonLink = ({ value, jsonKey, noLink, object, parentObject }) => {
  if (!noLink && isPeachIdValue(value)) {
    const prefix = value.slice(0, 2)

    if (prefix === 'CP' || jsonKey === 'companyId') {
      return <CompanyLink companyId={value} />
    }

    if (prefix === 'LT' || jsonKey === 'loanTypeId') {
      return <LoanTypeLink loanTypeId={value} />
    }

    if (prefix === 'RL' || jsonKey === 'roleId') {
      return <RoleLink roleId={value} />
    }

    if (prefix === 'BO' || jsonKey === 'personId' || jsonKey === 'borrowerId') {
      return <PersonLink personId={value} />
    }

    if (prefix === 'UR' || jsonKey === 'userId') {
      return <UserLink userId={value} />
    }

    if (prefix === 'EM' || jsonKey === 'employeeId') {
      return <EmployeeLink employeeId={value} />
    }

    if (prefix === 'TM' || jsonKey === 'teamId') {
      return <TeamLink teamId={value} />
    }

    if (prefix === 'LN' || jsonKey === 'loanId') {
      if (object === 'draw' || jsonKey === 'drawId') {
        return <DrawLink drawId={value} />
      } else {
        return <LoanLink loanId={value} />
      }
    }

    if (prefix === 'PT' || jsonKey === 'paymentInstrumentId') {
      return <PaymentInstrumentLink paymentInstrumentId={value} />
    }

    if (prefix === 'TX' || jsonKey === 'transactionId') {
      return <TransactionLink transactionId={value} />
    }

    if (prefix === 'IR' || jsonKey === 'investorId') {
      return <InvestorLink investorId={value} />
    }

    if (prefix === 'CS' || jsonKey === 'caseId') {
      return <CaseLink caseId={value} />
    }

    if (prefix === 'DD' || jsonKey === 'documentId') {
      return <DocumentLink documentId={value} />
    }

    if (prefix === 'CT' || jsonKey === 'contactId') {
      return <ContactLink contactId={value} />
    }

    if (prefix === 'DP' || jsonKey === 'purchaseId') {
      return <PurchaseLink purchaseId={value} />
    }

    if (prefix === 'CE' || jsonKey === 'caseTypeId') {
      return <CaseTypeLink caseTypeId={value} />
    }

    if (prefix === 'SC' || jsonKey === 'supercaseId') {
      return <SupercaseLink supercaseId={value} />
    }

    if (prefix === 'AP' || jsonKey === 'autopayPlanId') {
      return (
        <AutopayPlanLink autopayPlanId={value} parentObject={parentObject} />
      )
    }

    if (prefix === 'WT' || jsonKey === 'workflowTypeId') {
      return <WorkflowTypeLink workflowTypeId={value} />
    }

    if (prefix === 'WF') {
      // Use SmartLink which will try both variants
      const caseId =
        jsonKey === 'workflowId' && parentObject?.id
          ? parentObject.id
          : undefined
      return <WorkflowSmartLink caseId={caseId} workflowId={value} />
    }

    if (prefix === 'AD' || jsonKey === 'appDomainId') {
      return <AppDomainLink appDomainId={value} />
    }

    if (prefix === 'SR' || jsonKey === 'smartReviewId') {
      return <ServiceLink serviceId={value} />
    }
  }

  const type = value === null ? 'null' : value === '' ? 'empty' : 'id'

  return (
    <JsonDisplayValue type={type}>
      {value === null ? 'null' : value === '' ? 'empty' : `${value}`}
    </JsonDisplayValue>
  )
}

export default JsonLink
